import { PUBLIC_AUTHORIZATION, TOKEN_URL } from "@/utils/apiUrls";
import {
  accessTokenAtom,
  isAnonymousUserAtom,
  refreshTokenAtom,
  store,
} from "@/utils/atoms";
import { anonymousLoginStatus } from "@/utils/authentication";
import { createReferenceId } from "@/utils/initializeSentry";

/**
 * Ensures the PUBLIC token is fresh.
 * Fetches a new public (anonymous) token and updates the auth atoms.
 * If the fetch fails → throws → caller decides how to handle.
 */
export const ensurePublicTokenIsFresh = async (): Promise<void> => {
  await fetchPublicTokenAndSetAtoms();
};

const fetchPublicTokenAndSetAtoms = async () => {
  const referenceId = createReferenceId();
  const response = await fetch(
    `${TOKEN_URL.toString()}?grant_type=client_credentials&scope=all`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: PUBLIC_AUTHORIZATION,
        "X-Reference-Id": referenceId,
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch public token: ${response.status}`);
  }

  const json = await response.json();

  if (!json.access_token) {
    throw new Error("Failed to refresh public token");
  }

  store.set(accessTokenAtom, json.access_token);
  store.set(refreshTokenAtom, anonymousLoginStatus);
  store.set(isAnonymousUserAtom, true);
};
